import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=05b7767a&scoped=true"
import script from "./logDetail.vue?vue&type=script&lang=js"
export * from "./logDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7767a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b7767a')) {
      api.createRecord('05b7767a', component.options)
    } else {
      api.reload('05b7767a', component.options)
    }
    module.hot.accept("./logDetail.vue?vue&type=template&id=05b7767a&scoped=true", function () {
      api.rerender('05b7767a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/mealOrder/logDetail.vue"
export default component.exports